/**
 * Login page. Diaper UI does not host its own login form — it bounces the user
 * to the identity service, which redirects back here with the JWT in the URL
 * fragment after a successful sign-in. See stores/authStore.ts for the capture
 * logic.
 */
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export const LoginPage: React.FC = () => {
  const login = useAuthStore((s) => s.login);
  const location = useLocation();
  const sessionExpired = useAuthStore((s) => s.sessionExpired);
  const clear = useAuthStore((s) => s.clearSessionExpiredFlag);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const expired = params.get('expired') === '1' || sessionExpired;
    const from = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname;
    const returnTo = from && from !== '/login' ? `${window.location.origin}${from}` : window.location.origin;
    if (expired) clear();
    login(returnTo);
  }, [login, location, sessionExpired, clear]);

  return (
    <div className="min-h-screen flex items-center justify-center text-gray-600">
      Redirecting to identity provider…
    </div>
  );
};
